// Copyright 2022 Carnegie Mellon University. All Rights Reserved.
// Released under a MIT (SEI)-style license. See LICENSE.md in the
// project root for license information.

import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-data-option-edit-dialog',
    templateUrl: './data-option-edit-dialog.component.html',
    styleUrls: ['./data-option-edit-dialog.component.scss'],
    standalone: false
})

export class DataOptionEditDialogComponent {
  @Output() editComplete = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  errorFree() {
    return this.data.dataOption && this.data.dataOption.optionName && this.data.dataOption.optionName.length > 0 &&
      this.data.dataOption.optionValue && this.data.dataOption.optionValue.length > 0;
  }

  /**
   * Closes the edit screen
   */
  handleEditComplete(saveChanges: boolean): void {
    if (!saveChanges) {
      this.editComplete.emit({ saveChanges: false, dataOption: null });
    } else {
      if (this.errorFree) {
        this.editComplete.emit({
          saveChanges: saveChanges,
          dataOption: this.data.dataOption,
        });
      }
    }
  }

}
